import { configureStore } from "@reduxjs/toolkit";
import mainReducer from "./mainStore";
import detailReducer from "./detailStore";
import collapseReducer from "./collapseStore";
import wfSummaryReducer from "./wfSummaryStore";
import strategicChartReducer from "./strategicChartStore";
import wfTrackingReducer from "./wfTrackingStore";
import userReducer from "./userStore";
import wfStrategicSummaryReducer from "./wfStrategicSummaryStore";
import preferencesReducer from "./preferencesStore";
import globalReducer from "./globalStore";
import capacityReducer from "./capacityStore";
import dcContingencyReducer from "./dcContingencyStore";
import qualitySummaryReducer from "./qualitySummaryStore";
import qualityCpmReducer from "./qualityCpmStore";

export default configureStore({
  reducer: {
    user: userReducer,
    main: mainReducer,
    detail: detailReducer,
    collapse: collapseReducer,
    wfsummary: wfSummaryReducer,
    wfstrategicsummary: wfStrategicSummaryReducer,
    strchart: strategicChartReducer,
    wftracking: wfTrackingReducer,
    preferences: preferencesReducer,
    global: globalReducer,
    capacity: capacityReducer,
    dccontingency: dcContingencyReducer,
    qualitysummary: qualitySummaryReducer,
    qualitycpm: qualityCpmReducer,
  },
});
